module.exports = __webpack_public_path__ + "img/Mobile Solutions Banner Image.efd39d00.png";